import React, { useContext, useState } from 'react';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { KeyboardArrowDown } from '@mui/icons-material';
import styles from './common.module.scss';
import NestedModifiers from '../NestedModifiers';
import { IItemsModifier } from './common';
import { getFormattedPrice } from '../../helper/common';
import MenuItemsPageContext, { IMenuItemContext } from '../../../Contexts/MenuItemsPageContext/MenuItemsPageContext';
import { FormControlLabel, Radio } from '@mui/material';

interface IRadioButtonFieldProps {
	modifier: IItemsModifier;
	selectedModifierSets: string[];
	parentKey: string;
	handleModifiers(updateSelectedModifierSets: string[], selectedKey?: string, controlSelection?: string): void;
	isChildDisabled: boolean;
	modifierSetIndex: string;
}

const RadioButtonField: React.FC<IRadioButtonFieldProps> = ({
	modifier,
	selectedModifierSets,
	handleModifiers,
	isChildDisabled,
	parentKey,
	modifierSetIndex,
}: IRadioButtonFieldProps) => {
	const { merchantData } = useContext(MenuItemsPageContext) as IMenuItemContext;
	const [expand, setExpand] = useState(false);
	const { modifierRef } = modifier;
	const modifierName = modifier.modifierDetails?.name;
	const modifierPrice = modifier.modifierDetails?.price;
	const modifierSets = modifier.modifierSets || [];
	const modifierKey = modifier.key;
	const isChecked = selectedModifierSets.filter((modifierData) => modifierData === modifierKey).length > 0;

	const handleExpandCollapse = () => {
		setExpand(!expand);
	};

	const handleChange = () => {
		setExpand(true);
		const updateModifierSets: string[] = selectedModifierSets?.length ? selectedModifierSets : [];
		handleModifiers([...updateModifierSets, modifierKey], modifierKey, 'selected');
	};

	return (
		<div className={isChildDisabled ? `${styles.modifierBlock} ${styles.modifierDisabled}` : styles.modifierBlock}>
			<div className={`${styles.selectionBlock} ${styles.checkboxDiv}`}>
				<FormControlLabel
					control={
						<Radio
						id={`${modifierRef}-${parentKey}`}
						name={`${modifierRef}-${parentKey}`}
						value={modifierRef}
						onChange={handleChange}
						checked={isChecked}
						disabled={isChildDisabled}
						className={styles.radioButton}
						/>
					}
					label={''}
				/>
				{merchantData && (
					<>
						<label
							className={styles.labelBlock}
							htmlFor={`${modifierRef}-${parentKey}`}
						>
							<span className={styles.labelName}>
								{modifierName}{' '}
							</span>
							<div className={styles.labelBlockLeft}>
								<span className={styles.modifierPrice}>	
									{modifierPrice && modifierPrice !== 0
										? `+ ${getFormattedPrice(modifierPrice, merchantData?.currency)}`
										: null
									}
								</span>
							</div>
						</label>
						{modifierSets?.length > 0 && (
							<button className={styles.cartIconStyle} onClick={handleExpandCollapse}>
								{' '}
								{expand ? <KeyboardArrowDown /> : <KeyboardArrowRightIcon />}{' '}
							</button>
						)}
					</>
				)}
			</div>
			<div className={expand ? styles.modifierBody : styles.hideModifierBody}>
				{modifierSets?.length > 0 && (
					<NestedModifiers
						modifierSets={modifierSets}
						selectedModifierSets={selectedModifierSets}
						onHandleModifier={handleModifiers}
						isChildDisabled={false}
						modifierLastIndex={modifierSetIndex}
					/>
				)}
			</div>
		</div>
	);
};

export default RadioButtonField;
